import { render, staticRenderFns } from "./ChooseEntityWrapper.vue?vue&type=template&id=67d5f886"
import script from "./ChooseEntityWrapper.vue?vue&type=script&lang=js"
export * from "./ChooseEntityWrapper.vue?vue&type=script&lang=js"
import style0 from "./ChooseEntityWrapper.vue?vue&type=style&index=0&id=67d5f886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports